// extracted by mini-css-extract-plugin
module.exports = {"categoriesWrapper":"Categories_categoriesWrapper___ej7B","heading":"Categories_heading__rjSlp","title":"Categories_title__yGYuB","wrapper":"Categories_wrapper__tw9SS"};